module.exports = __webpack_public_path__ + "img/1-7-6.75741cf0.png";